import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import Select from 'react-select'
import Button from '@material-ui/core/Button'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { CircularProgress } from '@material-ui/core'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import getLoginId from '../../../utils/getLoginId'
import DecoupleDeviceSimDialog from '../../Modules/VehicleRegistartion/DecoupleDeviceSimDialog'
import ConfirmationalDialog from '../../common/ConfirmationDialog'

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int) {
    clients: allClientDetails(partnerLoginId: $partnerLoginId) {
      id
      clientName
      loginId
    }
  }
`

const GET_VEHICLES = gql`
  query getAllVehicleDetails($clientLoginId: Int) {
    vehicles: getAllVehicleDetails(clientLoginId: $clientLoginId) {
      entityId
      vehicleNumber
      videoTelematicsType
      videoTelematicsId
      deviceDetail {
        serial_num
        uniqueDeviceId
        deviceModelId {
          model_name
          devicetype
          __typename
        }
        __typename
      }
      simDetail {
      id
        phoneNumber
        __typename
      }
      solution_type
      __typename
    }
  }
`

// Fallback query with potentially different field names
const GET_VEHICLES_FALLBACK = gql`
  query getAllVehicleDetails($clientLoginId: Int) {
    getAllVehicleDetails(clientLoginId: $clientLoginId) {
      id
      vehicleNumber
      solution_type
      deviceDetail {
        uniqueDeviceId
        imeiNumber
        simNumber
        simProvider
        simStatus
      }
    }
  }
`

const GET_DASHCAM_REGISTRATIONS = gql`
  query GetDashcamRegistrations {
    getDashcamRegistrations {
      success
      message
      data {
        uuid
        simid
        memorycardid
        uniqueid
        vtid
        status
      }
    }
  }
`

const VT_REPLACEMENT_ONBOARDING = gql`
  mutation vtreplacementonboarding( $existingvtid: String, $newvtid: String, $solution_type: String, $existinguniqueid: String, $created_by: String, $updated_by: String) {
    vtreplacementonboarding( existingvtid: $existingvtid, newvtid: $newvtid, solution_type: $solution_type, existinguniqueid: $existinguniqueid, created_by: $created_by, updated_by: $updated_by) {
      success
      message
    }
  }
`

const styles = theme => ({
  root: {
    padding: 24,
    marginTop: 24
  },
  paper: {
    padding: 24,
    marginBottom: 16
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
  },
  selectBox: {
    width: '100%'
  },
  button: {
    margin: theme.spacing.unit,
  },
  vehicleInfoCard: {
    padding: 16,
    marginBottom: 16,
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    backgroundColor: '#f5f5f5'
  },
  vehicleInfoHeader: {
    fontWeight: 'bold',
    marginBottom: 12,
    fontSize: '1.1rem',
    color: '#333'
  },
  vehicleInfoDetails: {
    fontSize: '0.9rem',
    color: '#666'
  },
  infoRow: {
    marginBottom: 8,
    display: 'flex',
    justifyContent: 'space-between'
  },
  infoLabel: {
    fontWeight: '600',
    color: '#555'
  },
  infoValue: {
    color: '#333'
  },
  replacementSection: {
    marginTop: 16
  }
})

class DeviceReplacement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      replacementMode: 'device',
      selectedCustomer: null,
      selectedVehicle: null,
      selectedDevice: null,
      selectedSim: null,
      selectedFromDevice: null,
      selectedToDevice: null,
      selectedVTVehicle: null,
      loading: false,
      decoupleDialogOpen: false,
      alertDialogOpen: false,
      alertDialogMessage: '',
      alertDialogTitle: '',
      confirmDialogOpen: false,
      confirmDialogMessage: '',
      confirmDialogTitle: '',
      pendingAction: null
    }
  }

  handleCustomerChange = (selectedCustomer) => {
    this.setState({
      selectedCustomer,
      selectedVehicle: null,
      selectedDevice: null,
      selectedSim: null,
      selectedFromDevice: null,
      selectedToDevice: null,
      selectedVTVehicle: null
    })
  }

  handleVehicleChange = (selectedVehicle) => {
    this.setState({
      selectedVehicle,
      selectedDevice: null,
      selectedSim: null
    })
  }

  handleReplacementModeChange = (event, replacementMode) => {
    if (!replacementMode) return
    this.setState({
      replacementMode,
      selectedVehicle: null,
      selectedDevice: null,
      selectedSim: null,
      selectedFromDevice: null,
      selectedToDevice: null,
      selectedVTVehicle: null
    })
  }

  handleFromDeviceChange = selectedFromDevice => {
    this.setState({ selectedFromDevice, selectedToDevice: null })
  }

  handleToDeviceChange = selectedToDevice => {
    this.setState({ selectedToDevice })
  }

  handleVTVehicleChange = (selectedVTVehicle, dashcamRegistrations) => {
    const vehicle = selectedVTVehicle && selectedVTVehicle.vehicle
    const vtId = vehicle && vehicle.videoTelematicsId
    const rows = dashcamRegistrations &&
      dashcamRegistrations.getDashcamRegistrations &&
      dashcamRegistrations.getDashcamRegistrations.success &&
      Array.isArray(dashcamRegistrations.getDashcamRegistrations.data)
      ? dashcamRegistrations.getDashcamRegistrations.data
      : []
    const registration = rows.find(r => r.vtid === vtId)

    this.setState({
      selectedVTVehicle,
      selectedToDevice: null,
      selectedFromDevice: vtId
        ? {
          value: vtId,
          label: vtId,
          uniqueid: registration ? registration.uniqueid : null,
          vehicleNumber: vehicle.vehicleNumber
        }
        : null
    })
  }

  handleDeviceChange = (selectedDevice) => {
    this.setState({ selectedDevice })
  }

  handleSimChange = (selectedSim) => {
    this.setState({ selectedSim })
  }

  handleDecoupleDialogOpen = () => {
    this.setState({ decoupleDialogOpen: true })
  }

  handleDecoupleDialogClose = () => {
    this.setState({ decoupleDialogOpen: false })
  }

  handleSubmit = () => {
    const { replacementMode, selectedCustomer, selectedVehicle, selectedDevice, selectedSim, selectedFromDevice, selectedToDevice } = this.state
    if (!selectedCustomer) {
      this.setState({
        alertDialogOpen: true,
        alertDialogTitle: 'Validation Error',
        alertDialogMessage: 'Please select customer'
      })
      return
    }

    if (replacementMode === 'vt') {
      if (!selectedFromDevice || !selectedToDevice) {
        this.setState({
          alertDialogOpen: true,
          alertDialogTitle: 'Validation Error',
          alertDialogMessage: 'Please select current and target device'
        })
        return
      }

      this.setState({
        confirmDialogOpen: true,
        confirmDialogTitle: 'Confirm VT ID Replacement',
        confirmDialogMessage: `Are you sure you want to move the Video Telematics ID from ${selectedFromDevice.label} to ${selectedToDevice.label}? This only changes the VT ID - the vehicle's GPS device is not affected.`,
        pendingAction: 'vt'
      })
      return
    }

    if (!selectedVehicle) {
      this.setState({
        alertDialogOpen: true,
        alertDialogTitle: 'Validation Error',
        alertDialogMessage: 'Please select vehicle'
      })
      return
    }

    console.log('Submitting device replacement:', {
      customer: selectedCustomer,
      vehicle: selectedVehicle,
      device: selectedDevice,
      sim: selectedSim
    })

    // TODO: Implement actual submission logic
    this.setState({
      alertDialogOpen: true,
      alertDialogTitle: 'Success',
      alertDialogMessage: 'Device replacement submitted successfully!'
    })
  }

  handleCancel = () => {
    this.setState({
      replacementMode: 'device',
      selectedCustomer: null,
      selectedVehicle: null,
      selectedDevice: null,
      selectedSim: null,
      selectedFromDevice: null,
      selectedToDevice: null
    })
  }

  executeVTReplacement = () => {
    const { selectedFromDevice, selectedToDevice, selectedVTVehicle } = this.state
    const { client } = this.props

    if (!selectedFromDevice || !selectedToDevice || !selectedVTVehicle) return

    this.setState({ loading: true, confirmDialogOpen: false })

    client.mutate({
      mutation: VT_REPLACEMENT_ONBOARDING,
      variables: {
        existingvtid: selectedFromDevice.value,
        existinguniqueid: selectedFromDevice.uniqueid,
        newvtid: selectedToDevice.value,
        solution_type: selectedVTVehicle.vehicle && selectedVTVehicle.vehicle.solution_type ? (Array.isArray(selectedVTVehicle.vehicle.solution_type) ? selectedVTVehicle.vehicle.solution_type.join(',') : selectedVTVehicle.vehicle.solution_type) : null,
        created_by: localStorage.getItem('username'),
        updated_by: localStorage.getItem('username')
      }
    }).then(({ data }) => {
      this.setState({
        loading: false,
        alertDialogOpen: true,
        alertDialogTitle: data.vtreplacementonboarding.success ? 'Success' : 'Error',
        alertDialogMessage: data.vtreplacementonboarding.message
      })
    }).catch(error => {
      this.setState({
        loading: false,
        alertDialogOpen: true,
        alertDialogTitle: 'Error',
        alertDialogMessage: error.message || 'Something went wrong while replacing VT'
      })
    })
  }

  closeAlertDialog = () => {
    this.setState({ alertDialogOpen: false })
  }

  closeConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false })
  }

  render() {
    const { classes } = this.props
    const {
      replacementMode,
      selectedCustomer,
      selectedVehicle,
      selectedDevice,
      selectedSim,
      decoupleDialogOpen,
      selectedFromDevice,
      selectedToDevice,
      selectedVTVehicle,
      loading,
      alertDialogOpen,
      alertDialogMessage,
      alertDialogTitle,
      confirmDialogOpen,
      confirmDialogMessage,
      confirmDialogTitle
    } = this.state
    const partnerLoginId = getLoginId()

    // Get solution type from selected vehicle for the dialog
    const getSolutionType = () => {
      if (!selectedVehicle) return 'No Solution Type'
      // This would come from the vehicle data when selected
      return (Array.isArray(selectedVehicle.solution_type) ? selectedVehicle.solution_type.join(', ') : selectedVehicle.solution_type) || 'No Solution Type'
    }

    // Get device and SIM details for the dialog
    const getUniqueDeviceId = () => {
      if (!selectedVehicle) return null
      return selectedVehicle.deviceDetail && selectedVehicle.deviceDetail.uniqueDeviceId || null
    }

    const getSimPhoneNumber = () => {
      if (!selectedVehicle) return null
      return selectedVehicle.simDetail && selectedVehicle.simDetail.phoneNumber || null
    }

    const getSimId = () => {
      if (!selectedVehicle) return null
      return selectedVehicle.simDetail && selectedVehicle.simDetail.id || null
    }

    return (
      <div className={classes.root}>
        <Typography variant="h4" component="h1" gutterBottom>
          Device Replacement
        </Typography>

        <Paper className={classes.paper}>
          <Tabs
            value={replacementMode}
            onChange={this.handleReplacementModeChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab value="device" label="Device Replacement" />
            <Tab value="vt" label="VT ID Replacement" />
          </Tabs>
        </Paper>

        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            {/* Customer Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl} fullWidth>
                <FormGroup>
                  <Typography variant="subtitle1" gutterBottom>
                    Select Customer *
                  </Typography>
                  <Query query={GET_CLIENTS} variables={{ partnerLoginId }}>
                    {({ loading, error, data }) => {
                      if (loading) return <CircularProgress size={24} />
                      if (error) return <div>Error loading customers</div>

                      const customerOptions = data.clients.map(client => ({
                        value: client.loginId,
                        label: client.clientName,
                        ...client
                      }))

                      return (
                        <Select
                          value={selectedCustomer}
                          onChange={this.handleCustomerChange}
                          options={customerOptions}
                          placeholder="Select a customer"
                          className={classes.selectBox}
                        />
                      )
                    }}
                  </Query>
                </FormGroup>
              </FormControl>
            </Grid>

            {/* Vehicle Dropdown */}
            {replacementMode === 'device' && (
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.formControl} fullWidth>
                  <FormGroup>
                    <Typography variant="subtitle1" gutterBottom>
                      Select Vehicle *
                    </Typography>
                    {selectedCustomer ? (
                      <Query query={GET_VEHICLES} variables={{ clientLoginId: selectedCustomer.value }}>
                        {({ loading, error, data }) => {
                          if (loading) return <CircularProgress size={24} />
                          if (error) return <div>Error loading vehicles</div>

                          const vehicleOptions = data.vehicles.map(vehicle => ({
                            value: vehicle.entityId,
                            label: vehicle.vehicleNumber,
                            ...vehicle
                          }))

                          return (
                            <Select
                              value={selectedVehicle}
                              onChange={this.handleVehicleChange}
                              options={vehicleOptions}
                              placeholder="Select a vehicle"
                              className={classes.selectBox}
                            />
                          )
                        }}
                      </Query>
                    ) : (
                      <div style={{ color: '#666', padding: '8px' }}>
                        Please select a customer first
                      </div>
                    )}
                  </FormGroup>
                </FormControl>
              </Grid>
            )}
          </Grid>
        </Paper>

        {replacementMode === 'vt' && selectedCustomer && (
          <Query query={GET_DASHCAM_REGISTRATIONS} fetchPolicy="network-only">
            {({ loading: dashLoading, error: dashError, data: dashData }) => (
              <Paper className={classes.paper}>
                <Typography variant="h6" gutterBottom>
                  VT ID Replacement
                </Typography>
                <Typography variant="body2" style={{ color: '#666', marginBottom: 16 }}>
                  This replaces only the Video Telematics (VT) ID assigned to the vehicle - the unique ID is not affected.
                  To replace the unique ID itself, use the Device Replacement tab instead.
                </Typography>
                <Query query={GET_VEHICLES} variables={{ clientLoginId: selectedCustomer.value }}>
                  {({ loading: vLoading, error: vError, data: vData }) => (
                    <Query query={GET_VEHICLES} variables={{ clientLoginId: selectedCustomer.value }}>
                      {({ loading: sLoading, error: sError, data: sData }) => {
                        if (vLoading || sLoading) return <CircularProgress size={24} />
                        if (vError || sError) return <div>Error loading vehicles</div>

                        const selectedVTVehicleData = (vData.vehicles || []).map(v => {
                          const statusV = (sData.vehicles || []).find(sv => sv.entityId === v.entityId) || {}
                          return { ...v, ...statusV }
                        }).find(v => selectedVTVehicle && v.entityId === selectedVTVehicle.value)

                        const vehicleOptions = (vData.vehicles || []).map(v => {
                          const statusV = (sData.vehicles || []).find(sv => sv.entityId === v.entityId) || {}
                          return {
                            value: v.entityId,
                            label: v.vehicleNumber,
                            vehicle: { ...v, ...statusV }
                          }
                        })

                        const vtVehicles = vehicleOptions.map(o => o.vehicle).filter(v =>
                          (v && v.videoTelematicsType) || (v && v.videoTelematicsId)
                        )

                    const fromOptions = vtVehicles
                      .filter(v => v.deviceDetail && v.deviceDetail.uniqueDeviceId)
                      .map(v => ({
                        value: v.deviceDetail.uniqueDeviceId,
                        label: `${v.deviceDetail.uniqueDeviceId} (${v.vehicleNumber})`,
                        vehicle: v
                      }))

                    const toOptions = fromOptions.filter(o => !selectedFromDevice || o.value !== selectedFromDevice.value)

                    return (
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <FormControl className={classes.formControl} fullWidth>
                            <FormGroup>
                              <Typography variant="subtitle1" gutterBottom>
                                Select Vehicle *
                              </Typography>
                              <Select
                                value={selectedVTVehicle}
                                onChange={(val) => this.handleVTVehicleChange(val, dashData)}
                                options={vehicleOptions}
                                placeholder="Select a vehicle"
                                className={classes.selectBox}
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        {selectedVTVehicleData && (
                          <Grid item xs={12}>
                            <div className={classes.vehicleInfoCard} style={{ backgroundColor: selectedVTVehicleData.videoTelematicsId ? '#e8f5e9' : '#ffebee' }}>
                              <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                                VT Information for {selectedVTVehicleData.vehicleNumber}:
                              </Typography>
                              <div className={classes.infoRow} style={{ marginTop: '8px' }}>
                                <span className={classes.infoLabel}>Video Telematics Status:</span>
                                <span className={classes.infoValue} style={{ color: selectedVTVehicleData.videoTelematicsId ? 'green' : 'red', fontWeight: 'bold' }}>
                                  {selectedVTVehicleData.videoTelematicsId ? `Connected (ID: ${selectedVTVehicleData.videoTelematicsId})` : 'Not attached any'}
                                </span>
                              </div>
                              {selectedVTVehicleData.videoTelematicsType && (
                                <div className={classes.infoRow}>
                                  <span className={classes.infoLabel}>Telematics Type:</span>
                                  <span className={classes.infoValue}>{selectedVTVehicleData.videoTelematicsType}</span>
                                </div>
                              )}
                              {selectedVTVehicleData.videoTelematicsId && (
                                <div className={classes.infoRow}>
                                  <span className={classes.infoLabel}>Unique ID:</span>
                                  <span className={classes.infoValue}>
                                    {(() => {
                                      const rows = dashData &&
                                        dashData.getDashcamRegistrations &&
                                        dashData.getDashcamRegistrations.success &&
                                        Array.isArray(dashData.getDashcamRegistrations.data)
                                        ? dashData.getDashcamRegistrations.data
                                        : []
                                      const registration = rows.find(r => r.vtid === selectedVTVehicleData.videoTelematicsId)
                                      return registration ? registration.uniqueid : 'Not Available'
                                    })()}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Grid>
                        )}

                        <Grid item xs={12} sm={6}>
                          <FormControl className={classes.formControl} fullWidth>
                            <FormGroup>
                              <Typography variant="subtitle1" gutterBottom>
                                Current VT ID (From) *
                              </Typography>
                              {(() => {
                                if (dashLoading) return <CircularProgress size={24} />
                                if (dashError) return <div>Error loading MettaX VT IDs</div>

                                const rows = dashData &&
                                  dashData.getDashcamRegistrations &&
                                  dashData.getDashcamRegistrations.success &&
                                  Array.isArray(dashData.getDashcamRegistrations.data)
                                  ? dashData.getDashcamRegistrations.data
                                  : []

                                const vtidOptions = rows
                                  .filter(r => r && r.vtid)
                                  .map(r => ({
                                    label: r.vtid,
                                    value: r.vtid,
                                    simid: r.simid,
                                    memorycardid: r.memorycardid,
                                    uniqueid: r.uniqueid,
                                    status: r.status
                                  }))

                                return (
                                  <div style={{ pointerEvents: 'none', opacity: selectedVTVehicle ? 0.7 : 1 }}>
                                  <Select
                                    value={selectedFromDevice}
                                    onChange={() => {}}
                                    options={vtidOptions}
                                    placeholder="Current VT ID"
                                    className={classes.selectBox}
                                    isDisabled={!!selectedVTVehicle}
                                  />
                                </div>
                                )
                              })()}
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl className={classes.formControl} fullWidth>
                            <FormGroup>
                              <Typography variant="subtitle1" gutterBottom>
                                Target VT ID (To) *
                              </Typography>
                              {(() => {
                                if (dashLoading) return <CircularProgress size={24} />
                                if (dashError) return <div>Error loading MettaX VT IDs</div>

                                const rows2 = dashData &&
                                  dashData.getDashcamRegistrations &&
                                  dashData.getDashcamRegistrations.success &&
                                  Array.isArray(dashData.getDashcamRegistrations.data)
                                  ? dashData.getDashcamRegistrations.data
                                  : []

                                const availableOptions = rows2
                                  .filter(r => r && r.vtid && r.status === 'available')
                                  .filter(r => !selectedFromDevice || r.vtid !== selectedFromDevice.value)
                                  .map(r => ({
                                    label: r.vtid,
                                    value: r.vtid,
                                    simid: r.simid,
                                    memorycardid: r.memorycardid,
                                    uniqueid: r.uniqueid,
                                    status: r.status
                                  }))

                                return (
                                  <Select
                                    value={selectedToDevice}
                                    onChange={this.handleToDeviceChange}
                                    options={availableOptions}
                                    placeholder="Select target VT ID"
                                    className={classes.selectBox}
                                    isDisabled={!selectedFromDevice}
                                  />
                                )
                              })()}
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    )
                  }}
                </Query>
              )}
            </Query>
          </Paper>
        )}
      </Query>
    )}

        {/* Vehicle Information Display */}
        {replacementMode === 'device' && selectedVehicle && (
          <Paper className={classes.paper}>
            <Typography variant="h6" gutterBottom>
              Current Vehicle Information
            </Typography>
            <Query query={GET_VEHICLES} variables={{ clientLoginId: selectedCustomer.value }}>
              {({ loading, error, data }) => {
                if (loading) return <CircularProgress size={24} />
                if (error) return <div>Error loading vehicle details</div>

                const selectedVehicleData = data.vehicles.find(
                  vehicle => vehicle.entityId === selectedVehicle.value
                )

                if (!selectedVehicleData) {
                  return (
                    <div style={{ color: '#666', padding: '16px' }}>
                      Vehicle details not found
                    </div>
                  )
                }

                return (
                  <div className={classes.vehicleInfoCard}>
                    <div className={classes.vehicleInfoHeader}>
                      {selectedVehicleData.vehicleNumber}
                    </div>
                    <div className={classes.vehicleInfoDetails}>
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>Device Unique ID:</span>
                        <span className={classes.infoValue}>
                          {selectedVehicleData.deviceDetail && selectedVehicleData.deviceDetail.uniqueDeviceId
                            ? selectedVehicleData.deviceDetail.uniqueDeviceId
                            : 'Not Available'}
                        </span>
                      </div>
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>Solution Present:</span>
                        <span className={classes.infoValue}>
                          {selectedVehicleData.solution_type
                            ? (Array.isArray(selectedVehicleData.solution_type) ? selectedVehicleData.solution_type.join(', ').toUpperCase() : selectedVehicleData.solution_type.toUpperCase())
                            : 'No Solution'}
                        </span>
                      </div>
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>SIM Number:</span>
                        <span className={classes.infoValue}>
                          {selectedVehicleData.simDetail && selectedVehicleData.simDetail.phoneNumber
                            ? selectedVehicleData.simDetail.phoneNumber
                            : 'Not Available'}
                        </span>
                      </div>
                      <div className={classes.infoRow}>
                        <span className={classes.infoLabel}>Device Model:</span>
                        <span className={classes.infoValue}>
                          {selectedVehicleData.deviceDetail && selectedVehicleData.deviceDetail.deviceModelId && selectedVehicleData.deviceDetail.deviceModelId.model_name
                            ? selectedVehicleData.deviceDetail.deviceModelId.model_name
                            : 'Not Available'}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              }}
            </Query>
          </Paper>
        )}

        {/* Action Buttons */}
        {
          ((replacementMode === 'device' && selectedVehicle) || (replacementMode === 'vt' && selectedCustomer)) && (
            <Paper className={classes.paper}>
              <Grid container justify="flex-end" spacing={2}>
                {replacementMode === 'device' && (
                  <Grid item>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={this.handleDecoupleDialogOpen}
                      className={classes.button}
                    >
                      Decouple Device/Sim
                    </Button>
                  </Grid>
                )}
                <Grid item>
                  <Button
                    variant="outlined"
                    onClick={this.handleCancel}
                    className={classes.button}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  {replacementMode === 'vt' && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleSubmit}
                      disabled={!selectedCustomer || !selectedFromDevice || !selectedToDevice || loading}
                      className={classes.button}
                    >
                      {loading ? <CircularProgress size={24} /> : 'Submit Replacement'}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Paper>
          )
        }

        {/* Decouple Device/Sim Dialog */}
        {
          replacementMode === 'device' && (
            <DecoupleDeviceSimDialog
              open={decoupleDialogOpen}
              onClose={this.handleDecoupleDialogClose}
              solutionType={getSolutionType()}
              clientLoginId={selectedCustomer && selectedCustomer.value}
              uniqueDeviceId={getUniqueDeviceId()}
              simId={getSimId()}
              simPhoneNumber={getSimPhoneNumber()}
            />
          )
        }

        {/* Alert Dialog */}
        <ConfirmationalDialog
          isDialogOpen={alertDialogOpen}
          dialogTitle={alertDialogTitle}
          dialogMessage={alertDialogMessage}
          positiveResponseButtonText="OK"
          negativeResponseButtonText=""
          positiveResponseHandler={this.closeAlertDialog}
          negativeResponseHandler={this.closeAlertDialog}
          dialogCloseHandler={this.closeAlertDialog}
        />

        {/* Confirm Dialog */}
        <ConfirmationalDialog
          isDialogOpen={confirmDialogOpen}
          dialogTitle={confirmDialogTitle}
          dialogMessage={confirmDialogMessage}
          positiveResponseButtonText="Yes"
          negativeResponseButtonText="No"
          positiveResponseHandler={this.executeVTReplacement}
          negativeResponseHandler={this.closeConfirmDialog}
          dialogCloseHandler={this.closeConfirmDialog}
        />
      </div >
    )
  }
}

export default withStyles(styles)(withApollo(DeviceReplacement))



// WEBPACK FOOTER //
// ./src/components/Pages/DeviceReplacement/index.jsx